// extracted by mini-css-extract-plugin
export default {"wrapper":"OrderHostCardContent_wrapper__UgFC2","qr":"OrderHostCardContent_qr__GoIYH"};